import React from 'react';
import styled from 'styled-components';

export default styled(props => <div {...props}>$</div>)`
  position: absolute;
  bottom: 0;
  left: 0;
  line-height: 3rem;
  width: 1rem;
  text-align: right;
  color: #ced4da;
`;
